import { ProtocoloDetalle } from "../domain/entities/ProtocoloDetalle";
import { ProtocoloService } from "../domain/services/protocoloService";

export class GetProtocoloDetalle {
  constructor(private protocoloService: ProtocoloService) {}

  async execute(
    ordenDeTrabajo: number,
    token: string
  ): Promise<ProtocoloDetalle[]> {
    const colProtocolosDetalle: ProtocoloDetalle[] =
      await this.protocoloService.getProtocoloDetalle(ordenDeTrabajo, token);
    return colProtocolosDetalle;
  }
}
